var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoglogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8E9B",
    d: "M44.212,19.638v3.098h9.42v-5.52C53.633,17.216,45.389,13.253,44.212,19.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A8E9B",
    d: "M26.38,17.216v5.52h9.42v-3.098C34.623,13.253,26.38,17.216,26.38,17.216z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E49A61",
    d: "M25.944,55.222c-0.215,0-0.429-0.066-0.602-0.193c-4.881-3.555-5.967-9.008-5.967-16.107 c0-14.389,9.234-19.539,20.625-19.539c11.392,0,20.626,5.15,20.626,19.539c0,7.1-1.085,12.553-5.967,16.107 c-0.173,0.127-0.388,0.193-0.603,0.193H25.944z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1BB6B",
    d: "M40,59.286c0,0.588-0.102,1.152-0.289,1.674c-0.914,2.555-3.943,3.705-6.442,2.648 c-1.794-0.76-3.471-1.82-4.995-3.139c-2.037-1.762-3.033-4.475-2.535-7.121c1.53-8.143,7.334-11.182,14.26-11.182 c6.926,0,12.73,3.039,14.261,11.182c0.498,2.646-0.498,5.359-2.535,7.121c-1.524,1.318-3.201,2.379-4.995,3.139 c-2.5,1.057-5.528-0.094-6.442-2.648C40.102,60.439,40,59.874,40,59.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M36.573,34.333c0,3.473-2.155,6.287-4.812,6.287s-4.812-2.814-4.812-6.287c0-3.471,2.155-4.713,4.812-4.713 S36.573,30.862,36.573,34.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M52.858,34.333c0,3.473-2.155,6.287-4.812,6.287s-4.812-2.814-4.812-6.287c0-3.471,2.155-4.713,4.812-4.713 S52.858,30.862,52.858,34.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525C6B",
    d: "M40,47.202c3.038,0,5.5,0.125,5.5,3.014c0,2.295-3.478,3.672-4.902,4.139c-0.39,0.129-0.805,0.129-1.195,0 c-1.424-0.467-4.903-1.844-4.903-4.139C34.5,47.327,36.963,47.202,40,47.202z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#525C6B",
    cx: 31.76,
    cy: 34.577,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#525C6B",
    cx: 48.046,
    cy: 34.577,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E49A61",
    d: "M50.046,52.804c0,0.451-0.366,0.818-0.818,0.818c-0.452,0-0.818-0.367-0.818-0.818 c0-0.453,0.366-0.818,0.818-0.818C49.679,51.985,50.046,52.351,50.046,52.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E49A61",
    d: "M46.773,54.985c0,0.451-0.366,0.818-0.818,0.818c-0.452,0-0.818-0.367-0.818-0.818 c0-0.451,0.366-0.818,0.818-0.818C46.406,54.167,46.773,54.534,46.773,54.985z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E49A61",
    d: "M48.955,58.259c0,0.451-0.366,0.816-0.818,0.816c-0.452,0-0.818-0.365-0.818-0.816 c0-0.453,0.366-0.818,0.818-0.818C48.589,57.44,48.955,57.806,48.955,58.259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E49A61",
    d: "M45.682,60.44c0,0.451-0.366,0.818-0.818,0.818c-0.452,0-0.818-0.367-0.818-0.818 c0-0.453,0.366-0.818,0.818-0.818C45.316,59.622,45.682,59.987,45.682,60.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E49A61",
    d: "M30.044,52.804c0,0.451,0.366,0.818,0.818,0.818c0.452,0,0.818-0.367,0.818-0.818 c0-0.453-0.366-0.818-0.818-0.818C30.41,51.985,30.044,52.351,30.044,52.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E49A61",
    d: "M33.317,54.985c0,0.451,0.366,0.818,0.818,0.818c0.452,0,0.818-0.367,0.818-0.818 c0-0.451-0.366-0.818-0.818-0.818C33.683,54.167,33.317,54.534,33.317,54.985z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E49A61",
    d: "M31.135,58.259c0,0.451,0.366,0.816,0.818,0.816c0.452,0,0.818-0.365,0.818-0.816 c0-0.453-0.366-0.818-0.818-0.818C31.501,57.44,31.135,57.806,31.135,58.259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E49A61",
    d: "M34.408,60.44c0,0.451,0.366,0.818,0.818,0.818c0.452,0,0.818-0.367,0.818-0.818 c0-0.453-0.366-0.818-0.818-0.818C34.774,59.622,34.408,59.987,34.408,60.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1BB6B",
    d: "M56.823,18.819c-3.456-1.717-5.986-3.656-7.713-0.182c-1.726,3.475-0.323,7.684,3.133,9.4 c3.457,1.717,7.658,0.291,9.384-3.184c0.915-1.842,0.48-2.945-0.646-3.83L56.823,18.819z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1BB6B",
    d: "M23.176,18.819c3.457-1.717,5.986-3.656,7.713-0.182c1.726,3.475,0.323,7.684-3.133,9.4 c-3.456,1.717-7.658,0.291-9.384-3.184c-0.916-1.842-0.48-2.945,0.646-3.83L23.176,18.819z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoglogo);
export default __webpack_public_path__ + "static/media/doglogo.657e4ef6f1c8790c81122cde067e87b8.svg";
export { ForwardRef as ReactComponent };